(function () {
  const FORUM_TAXONOMY = [
    { slug: "intestino", name: "Benessere intestinale", product: "ProbioBENE", productLine: "Probioticamente", productClaim: "Supporto quotidiano per pancia e digestione." },
    { slug: "immunita", name: "Difese immunitarie", product: "Agape N.27 Reishi", productLine: "Agape", productClaim: "Per sostenere le naturali difese." },
    { slug: "energia", name: "Energia e vitalità", product: "Magnesio 8", productLine: "HeBio", productClaim: "Minerali per energia, muscoli e vitalità." },
    { slug: "sonno", name: "Sonno e riposo", product: "MelaNight", productLine: "HeBio", productClaim: "Per accompagnare il riposo notturno." },
    { slug: "mente", name: "Mente e sistema nervoso", product: "N.46 GABA", productLine: "Agape", productClaim: "Serenità, umore e lucidità." },
    { slug: "cuore", name: "Cuore e circolazione", product: "Omega 3", productLine: "Bio-Clock", productClaim: "Benessere cardiovascolare quotidiano." },
    { slug: "ossa", name: "Ossa, muscoli e articolazioni", product: "N.03 Vitamina D3", productLine: "Agape", productClaim: "Supporto per ossa e funzionalità muscolare." },
    { slug: "metabolica", name: "Salute metabolica", product: "N.54 Berberina", productLine: "Agape", productClaim: "Supporto per glicemia, metabolismo e peso." },
    { slug: "colesterolo", name: "Colesterolo", product: "N.54 Berberina", productLine: "Agape", productClaim: "Formula per il metabolismo lipidico." },
    { slug: "detox", name: "Detox e depurazione", product: "NAC", productLine: "HeBio", productClaim: "Per fegato e depurazione." },
    { slug: "longevita", name: "Longevità e prevenzione", product: "N.11 Antiossidante", productLine: "Agape", productClaim: "Protezione antiossidante e prevenzione." },
    { slug: "donna", name: "Benessere femminile", product: "Femmina Plus", productLine: "HeBio", productClaim: "Equilibrio femminile e benessere intimo." },
    { slug: "prostata", name: "Prostata", product: "N.11 + Omega 3", productLine: "Bio-Clock", productClaim: "Supporto dedicato al benessere della prostata." },
    { slug: "generale", name: "Generale", product: "Magnesio 8", productLine: "HeBio", productClaim: "Domande generali sul benessere." },
  ];

  document.querySelectorAll(".forum-app").forEach(initForum);

  async function initForum(root) {
    const appUrl = normalizeAppUrl(root.dataset.appUrl);
    const customerApi = "/apps/forum";
    const shop = root.dataset.shop;
    const customerId = root.dataset.customerId || "";
    const limit = parseInt(root.dataset.pageSize, 10) || 6;
    const categoryFilter = root.querySelector("[data-forum-category-filter]");
    const categoryInput = root.querySelector("[data-forum-category-input]");
    const searchInput = root.querySelector("[data-forum-search]");
    const sortFilter = root.querySelector("[data-forum-sort]");
    const controls = root.querySelector(".forum-controls");
    const contentGrid = root.querySelector(".forum-content-grid");
    const list = root.querySelector("[data-forum-list]");
    const detail = root.querySelector("[data-forum-detail]");
    const askPage = root.querySelector("[data-forum-ask-page]");
    const askCta = root.querySelector("[data-forum-ask-cta]");
    const tabs = root.querySelectorAll("[data-forum-view]");
    const pagination = root.querySelector("[data-forum-pagination]");
    const summary = root.querySelector("[data-forum-summary]");
    const form = root.querySelector("[data-forum-form]");
    const message = root.querySelector("[data-forum-message]");
    const categorySidebar = root.querySelector("[data-forum-category-sidebar]");
    const productsPanel = root.querySelector("[data-forum-products]");
    const thankYou = root.querySelector("[data-forum-thank-you]");
    const disclaimerModal = root.querySelector("[data-forum-disclaimer-modal]");
    const selectedProductGroups = readSelectedProductGroups(root);

    const params = new URLSearchParams(window.location.search);
    const state = {
      categories: [],
      questions: [],
      pagination: { page: parseInt(params.get("page"), 10) || 1, total: 0, totalPages: 1 },
      selectedCategory: params.get("category") || root.dataset.initialCategory || "",
      searchQuery: params.get("q") || "",
      sort: ["views", "open", "resolved"].includes(params.get("sort")) ? params.get("sort") : "recent",
      selectedQuestionId: params.get("question") || "",
      view: params.get("view") === "mine" ? "mine" : "all",
      productIndex: 0,
      loading: false,
      error: "",
    };

    if (!appUrl || !shop) {
      list.innerHTML = emptyState("Forum non configurato.", "Imposta URL app e shop nelle impostazioni della sezione.");
      return;
    }

    await loadCategories();
    if (searchInput) searchInput.value = state.searchQuery;
    if (sortFilter) sortFilter.value = state.sort;
    bindStaticUi();
    startProductRotation();
    removeStaleAskParam();
    await routeFromState({ replace: true });

    tabs.forEach((tab) => {
      tab.addEventListener("click", async () => {
        state.view = tab.dataset.forumView;
        state.selectedQuestionId = "";
        state.pagination.page = 1;
        await routeFromState();
      });
    });

    if (categoryFilter) {
      categoryFilter.addEventListener("change", async () => {
        state.selectedCategory = categoryFilter.value;
        state.selectedQuestionId = "";
        state.pagination.page = 1;
        state.productIndex = 0;
        await routeFromState();
      });
    }

    if (searchInput) {
      let searchTimer;
      searchInput.addEventListener("input", () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(async () => {
          state.searchQuery = searchInput.value.trim();
          state.selectedQuestionId = "";
          state.pagination.page = 1;
          await routeFromState();
        }, 250);
      });
    }

    if (sortFilter) {
      sortFilter.addEventListener("change", async () => {
        state.sort = ["views", "open", "resolved"].includes(sortFilter.value) ? sortFilter.value : "recent";
        state.selectedQuestionId = "";
        state.pagination.page = 1;
        await routeFromState();
      });
    }

    root.querySelectorAll("[data-forum-ask-link]").forEach((link) => {
      link.addEventListener("click", async (event) => {
        event.preventDefault();
        state.view = "ask";
        state.selectedQuestionId = "";
        await routeFromState();
      });
    });

    root.querySelectorAll("[data-forum-back]").forEach((button) => {
      button.addEventListener("click", async () => {
        state.selectedQuestionId = "";
        state.view = state.view === "ask" ? "all" : state.view;
        await routeFromState();
      });
    });

    window.addEventListener("popstate", async () => {
      const nextParams = new URLSearchParams(window.location.search);
      state.selectedQuestionId = nextParams.get("question") || "";
      state.selectedCategory = nextParams.get("category") || "";
      state.searchQuery = nextParams.get("q") || "";
      if (searchInput) searchInput.value = state.searchQuery;
      state.sort = ["views", "open", "resolved"].includes(nextParams.get("sort")) ? nextParams.get("sort") : "recent";
      if (sortFilter) sortFilter.value = state.sort;
      state.pagination.page = parseInt(nextParams.get("page"), 10) || 1;
      state.view = nextParams.get("view") === "mine" ? "mine" : "all";
      await routeFromState({ replace: true });
    });

    if (form) {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const formData = new FormData(form);
        const submitButton = form.querySelector("button[type='submit']");
        if (submitButton) submitButton.disabled = true;
        setMessage("Invio in corso...", "info");

        try {
          const res = await fetch(`${customerApi}/questions`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              shop,
              categorySlug: formData.get("categorySlug") || "generale",
              title: formData.get("title"),
              question: formData.get("question"),
            }),
          });
          const data = await res.json().catch(() => ({}));

          if (!res.ok) {
            setMessage(data.error || "Errore durante l'invio. Riprova.", "error");
            return;
          }

          form.reset();
          renderCategoryControls();
          setMessage("", "success");
          state.view = "thanks";
          state.pagination.page = 1;
          await loadQuestions();
          renderCurrentView();
          pushState();
        } catch (err) {
          setMessage("Connessione non disponibile. Riprova tra poco.", "error");
        } finally {
          if (submitButton) submitButton.disabled = false;
        }
      });
    }

    function bindStaticUi() {
      root.querySelectorAll("[data-forum-disclaimer-open]").forEach((button) => {
        button.addEventListener("click", () => {
          if (disclaimerModal?.showModal) disclaimerModal.showModal();
        });
      });
      root.querySelectorAll("[data-forum-disclaimer-close]").forEach((button) => {
        button.addEventListener("click", () => disclaimerModal?.close());
      });
      root.querySelectorAll("[data-forum-thank-back]").forEach((button) => {
        button.addEventListener("click", async () => {
          state.view = customerId ? "mine" : "all";
          await routeFromState();
        });
      });
    }

    function removeStaleAskParam() {
      const url = new URL(window.location.href);
      if (!url.searchParams.has("ask")) return;
      url.searchParams.delete("ask");
      history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
    }

    async function loadCategories() {
      try {
        const res = await fetch(`${appUrl}/api/forum/categories?shop=${encodeURIComponent(shop)}`);
        const data = await res.json();
        state.categories = mergeForumCategories(data.categories || []);
      } catch (err) {
        state.categories = mergeForumCategories([]);
      }

      if (state.selectedCategory && !state.categories.some((category) => category.slug === state.selectedCategory)) {
        state.selectedCategory = "";
      }
      renderCategoryControls();
      renderProducts();
    }

    async function routeFromState(options = {}) {
      if (state.view !== "ask" && state.view !== "thanks") {
        await loadQuestions();
      }

      if (state.selectedQuestionId) {
        await showQuestion(state.selectedQuestionId);
      } else {
        renderCurrentView();
      }
      renderProducts();

      if (!options.replace) pushState();
    }

    async function loadQuestions() {
      state.loading = true;
      renderLoading();
      const params = new URLSearchParams({
        shop,
        page: String(state.pagination.page),
        limit: String(limit),
      });
      if (state.selectedCategory) params.set("category", state.selectedCategory);
      if (state.searchQuery) params.set("q", state.searchQuery);
      if (state.sort === "views") params.set("sort", state.sort);
      if (state.sort === "open") params.set("status", "open");
      if (state.sort === "resolved") params.set("status", "resolved");
      if (state.view === "mine" && customerId) {
        params.set("mine", "1");
      }

      try {
        const res = await fetch(`${customerId ? customerApi : `${appUrl}/api/forum`}/questions?${params.toString()}`);
        if (!res.ok) throw new Error("Forum request failed");
        const data = await res.json();
        state.questions = data.questions || [];
        state.pagination = data.pagination || { page: 1, total: state.questions.length, totalPages: 1 };
        state.error = "";
        renderCategoryControls();
      } catch (err) {
        state.questions = [];
        state.pagination = { page: 1, total: 0, totalPages: 1 };
        state.error = "Non riesco a caricare le domande.";
        renderCategoryControls();
      } finally {
        state.loading = false;
      }
    }

    function renderCurrentView() {
      setVisible(state.view);
      renderTabs();

      if (state.view === "ask") {
        renderSummary("");
        return;
      }

      if (state.view === "thanks") {
        setVisible("thanks");
        renderSummary("");
        renderPagination();
        return;
      }

      if (state.view === "mine" && !customerId) {
        list.innerHTML = loginState();
        renderSummary("");
        renderPagination();
        return;
      }

      if (state.error) {
        list.innerHTML = emptyState(state.error, "Riprova tra qualche minuto.");
        renderSummary("");
        renderPagination();
        return;
      }

      if (!state.questions.length) {
        const title = state.view === "mine" ? "Non hai ancora inviato domande." : "Nessuna domanda pubblicata.";
        const body = state.selectedCategory ? "Prova a cambiare categoria." : "Quando saranno disponibili, le troverai qui.";
        list.innerHTML = emptyState(
          state.searchQuery ? "Nessuna domanda trovata." : title,
          state.searchQuery ? "Vuoi farla tu? Usa il pulsante Inserisci una nuova domanda." : body
        );
      } else {
        list.innerHTML = state.questions.map(renderQuestionCard).join("");
        list.querySelectorAll("[data-question-id]").forEach((link) => {
          link.addEventListener("click", async (event) => {
            event.preventDefault();
            state.selectedQuestionId = link.dataset.questionId;
            await showQuestion(state.selectedQuestionId);
            pushState();
          });
        });
      }

      const searchSuffix = state.searchQuery ? ` per "${state.searchQuery}"` : "";
      renderSummary(`${state.pagination.total} risultat${state.pagination.total === 1 ? "o" : "i"}${searchSuffix}`);
      renderPagination();
    }

    function renderQuestionCard(q) {
      const answerCount = publishedAnswerCount(q);
      const answerLabel = answerCount ? `${answerCount} rispost${answerCount === 1 ? "a" : "e"}` : "In attesa di risposta";
      const displayStatus = displayQuestionStatus(q);
      return `
        <article class="forum-item">
          <a class="forum-question-button" href="${questionUrl(q.id)}" data-question-id="${escapeHtml(q.id)}">
            <div class="forum-item-top">
              ${categoryPill(q)}
              <span class="forum-status forum-status--${escapeHtml(displayStatus)}">${statusLabel(displayStatus)}</span>
            </div>
            <h3>${highlight(q.title)}</h3>
            <p>${highlight(excerpt(q.body, 190))}</p>
            <p class="forum-question-author"><strong>Domanda posta da:</strong> ${escapeHtml(questionAuthor(q))}</p>
            <div class="forum-item-footer">
              <span>${questionMeta(q)}</span>
              <span>${escapeHtml(answerLabel)} · ${viewsLabel(q)}</span>
            </div>
          </a>
        </article>
      `;
    }

    async function showQuestion(questionId) {
      let question = state.questions.find((item) => item.id === questionId);
      if (!question) {
        question = await fetchQuestion(questionId);
      }
      if (!question) {
        renderCurrentView();
        return;
      }

      setVisible("detail");
      renderTabs();
      renderSummary("");
      const meta = questionMeta(question);
      detail.innerHTML = `
        <button class="forum-back" type="button" data-detail-back>Indietro</button>
        <article class="forum-detail-card">
          <div class="forum-item-top">
            ${categoryPill(question)}
            <span class="forum-status forum-status--${escapeHtml(displayQuestionStatus(question))}">${statusLabel(displayQuestionStatus(question))}</span>
          </div>
          <span class="forum-date">${meta}${meta ? " · " : ""}<span data-forum-view-count>${viewsLabel(question)}</span></span>
          <h2>${escapeHtml(question.title)}</h2>
          <div class="forum-prose">${paragraphs(question.body)}</div>
          <p class="forum-question-author"><strong>Domanda posta da:</strong> ${escapeHtml(questionAuthor(question))}</p>
          ${renderAnswers(question)}
        </article>
      `;
      detail.querySelector("[data-detail-back]").addEventListener("click", async () => {
        state.selectedQuestionId = "";
        await routeFromState();
      });
      trackQuestionView(question);
    }

    async function trackQuestionView(question) {
      if (!question || !question.id || question.status !== "published") return;

      const storageKey = `forum-question-viewed:${question.id}`;
      try {
        if (window.sessionStorage.getItem(storageKey)) return;
        window.sessionStorage.setItem(storageKey, "1");
      } catch (err) {
        // If storage is unavailable, still record the view once for this render.
      }

      try {
        const res = await fetch(`${appUrl}/api/forum/questions/${encodeURIComponent(question.id)}/view`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ shop }),
        });
        if (!res.ok) return;
        const data = await res.json();
        if (typeof data.viewCount !== "number") return;

        question.viewCount = data.viewCount;
        const listedQuestion = state.questions.find((item) => item.id === question.id);
        if (listedQuestion) listedQuestion.viewCount = data.viewCount;

        const countEl = detail.querySelector("[data-forum-view-count]");
        if (countEl) countEl.textContent = viewsLabel(question);
      } catch (err) {
        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (storageErr) {
          // Nothing to do if storage cannot be updated.
        }
      }
    }

    async function fetchQuestion(questionId) {
      const params = new URLSearchParams({ shop, id: questionId });
      try {
        const res = await fetch(`${customerId ? customerApi : `${appUrl}/api/forum`}/questions?${params.toString()}`);
        if (!res.ok) return null;
        const data = await res.json();
        return data.question || null;
      } catch (err) {
        return null;
      }
    }

    function renderAnswers(question) {
      const answers = Array.isArray(question.answers) && question.answers.length
        ? question.answers
        : question.answer
          ? [{ body: question.answer, createdAt: question.updatedAt }]
          : [];

      if (!answers.length) {
        return `<div class="forum-answer forum-answer--empty"><strong>Risposta in arrivo</strong><p>La domanda e stata ricevuta ed e in attesa di risposta.</p></div>`;
      }

      return answers.map((answer) => `
        <div class="forum-answer">
          <div class="forum-answer-heading">
            <strong>Risposta</strong>
            <span>${formatDate(answer.publishedAt || answer.createdAt || question.updatedAt)}</span>
          </div>
          <div class="forum-prose">${paragraphs(answer.body)}</div>
        </div>
      `).join("");
    }

    function renderPagination() {
      if (!pagination) return;
      const page = state.pagination.page || 1;
      const totalPages = state.pagination.totalPages || 1;
      if (state.view === "ask" || state.view === "thanks" || totalPages <= 1) {
        pagination.innerHTML = "";
        return;
      }

      pagination.innerHTML = `
        <button type="button" data-page="prev" ${page <= 1 ? "disabled" : ""}>Precedente</button>
        <span>Pagina ${page} di ${totalPages}</span>
        <button type="button" data-page="next" ${page >= totalPages ? "disabled" : ""}>Successiva</button>
      `;
      pagination.querySelectorAll("[data-page]").forEach((button) => {
        button.addEventListener("click", async () => {
          state.pagination.page += button.dataset.page === "next" ? 1 : -1;
          await routeFromState();
          scrollToResults();
        });
      });
    }

    function scrollToResults() {
      list.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function renderCategoryControls() {
      const visibleCategories = state.categories.filter((category) => !isInternalCategory(category));
      const formCategories = visibleCategories.length
        ? visibleCategories
        : [{ name: "Generale", slug: "generale", publishedQuestions: 0 }];
      const options = [
        `<option value="">Tutte le categorie</option>`,
        ...visibleCategories.map((category) => (
          `<option value="${escapeHtml(category.slug)}">${escapeHtml(category.name)} (${category.publishedQuestions || 0})</option>`
        )),
      ].join("");

      if (categoryFilter) {
        categoryFilter.innerHTML = options;
        categoryFilter.value = state.selectedCategory;
      }
      if (categorySidebar) {
        categorySidebar.innerHTML = [
          `<button type="button" class="forum-category-nav ${state.selectedCategory ? "" : "is-active"}" data-category="">
            <span>Tutte</span>
            <small>${totalCategoryCount()}</small>
          </button>`,
          ...visibleCategories.map((category) => `
            <button type="button" class="forum-category-nav ${category.slug === state.selectedCategory ? "is-active" : ""}" data-category="${escapeHtml(category.slug)}">
              <span>${escapeHtml(category.name)}</span>
              <small>${category.publishedQuestions || 0}</small>
            </button>
          `),
        ].join("");
        categorySidebar.querySelectorAll("[data-category]").forEach((button) => {
          button.addEventListener("click", async () => {
            state.selectedCategory = button.dataset.category;
            state.selectedQuestionId = "";
            state.pagination.page = 1;
            state.productIndex = 0;
            await routeFromState();
          });
        });
      }
      if (categoryInput) {
        categoryInput.innerHTML = formCategories.map((category) => (
          `<option value="${escapeHtml(category.slug)}">${escapeHtml(category.name)}</option>`
        )).join("");
        categoryInput.value = formCategories.some((category) => category.slug === state.selectedCategory)
          ? state.selectedCategory
          : formCategories[0]?.slug || "";
      }
    }

    function renderProducts() {
      if (!productsPanel) return;
      const category = state.selectedCategory
        ? state.categories.find((item) => item.slug === state.selectedCategory)
        : null;
      const fallbackCategory = category || state.categories.find((item) => item.slug === "generale") || state.categories[0];
      if (!fallbackCategory) {
        productsPanel.innerHTML = "";
        return;
      }
      const products = productSuggestions(fallbackCategory, Boolean(category));
      const activeIndex = state.productIndex % products.length;
      productsPanel.innerHTML = `
        <h3>I nostri prodotti consigliati</h3>
        ${products.map((product, index) => `
          <div class="forum-product-card ${index === activeIndex ? "is-active" : ""}">
            ${product.image
              ? `<img class="forum-product-image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title || product.product || "Prodotto consigliato")}" loading="lazy">`
              : `<div class="forum-product-image" aria-hidden="true">${escapeHtml((product.product || product.title || "H").slice(0, 1))}</div>`
            }
            <span>${escapeHtml(product.productLine || product.vendor || "HeBio")}</span>
            <strong>${escapeHtml(product.product || product.title || "Magnesio 8")}</strong>
            <p>${escapeHtml(product.productClaim || "Consiglio collegato alla categoria selezionata.")}</p>
            <a href="${escapeHtml(product.url || `/search?q=${encodeURIComponent(product.product || product.title || "HeBio")}`)}">Scopri</a>
          </div>
        `).join("")}
        <div class="forum-product-dots">
          ${products.map((_, index) => `<button type="button" class="${index === activeIndex ? "is-active" : ""}" data-product-index="${index}" aria-label="Mostra prodotto ${index + 1}"></button>`).join("")}
        </div>
      `;
      productsPanel.querySelectorAll("[data-product-index]").forEach((button) => {
        button.addEventListener("click", () => {
          state.productIndex = Number(button.dataset.productIndex) || 0;
          renderProducts();
        });
      });
    }

    function totalCategoryCount() {
      return Number(state.pagination.total || 0) || state.categories.reduce((total, category) => total + Number(category.publishedQuestions || 0), 0);
    }

    function productSuggestions(category, hasActiveCategory) {
      if (hasActiveCategory) {
        const categoryProducts = selectedProductGroups[category.slug] || [];
        if (categoryProducts.length) {
          return categoryProducts;
        }
      }
      if (selectedProductGroups.default?.length) {
        return selectedProductGroups.default;
      }
      const fallbackSlugs = ["generale", "immunita", "intestino"];
      const items = [category, ...fallbackSlugs.map((slug) => state.categories.find((item) => item.slug === slug))]
        .filter(Boolean)
        .filter((item, index, list) => list.findIndex((candidate) => candidate.product === item.product) === index);
      return items.length ? items.slice(0, 3) : [category];
    }

    function startProductRotation() {
      if (!productsPanel) return;
      let paused = false;
      productsPanel.addEventListener("mouseenter", () => { paused = true; });
      productsPanel.addEventListener("mouseleave", () => { paused = false; });
      setInterval(() => {
        if (paused || !state.categories.length) return;
        state.productIndex += 1;
        renderProducts();
      }, 5000);
    }

    function highlight(value) {
      const text = escapeHtml(value);
      const query = state.searchQuery.trim();
      if (!query) return text;
      const safeQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return text.replace(new RegExp(`(${safeQuery})`, "ig"), "<mark>$1</mark>");
    }

    function displayQuestionStatus(question) {
      if (question.status === "closed") return "closed";
      if (question.status === "hidden") return "hidden";
      if (questionHasPublishedAnswer(question)) return "resolved";
      return "pending";
    }

    function questionHasPublishedAnswer(question) {
      return publishedAnswerCount(question) > 0;
    }

    function publishedAnswerCount(question) {
      if (Array.isArray(question.answers)) {
        return question.answers.filter((answer) => {
          const body = String(answer?.body || "").trim();
          return body && answer.status !== "hidden";
        }).length;
      }
      return String(question.answer || "").trim() ? 1 : 0;
    }

    function setVisible(view) {
      const standaloneView = view === "ask" || view === "thanks";
      if (controls) controls.hidden = standaloneView;
      if (contentGrid) contentGrid.hidden = standaloneView;
      list.hidden = view !== "all" && view !== "mine";
      detail.hidden = view !== "detail";
      askPage.hidden = view !== "ask";
      if (thankYou) thankYou.hidden = view !== "thanks";
      if (askCta) askCta.hidden = view === "ask" || view === "detail";
    }

    function renderTabs() {
      tabs.forEach((tab) => {
        const active = tab.dataset.forumView === state.view || (state.view === "detail" && tab.dataset.forumView === "all");
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });
    }

    function renderSummary(text) {
      if (summary) summary.textContent = text;
    }

    function renderLoading() {
      list.innerHTML = `<div class="forum-skeleton"><span></span><span></span><span></span></div>`;
    }

    function setMessage(text, type) {
      if (!message) return;
      message.textContent = text;
      message.dataset.type = type;
    }

    function pushState() {
      history.pushState({}, "", currentUrl());
    }

    function currentUrl() {
      const url = new URL(window.location.href);
      url.searchParams.delete("question");
      url.searchParams.delete("ask");
      url.searchParams.delete("view");
      url.searchParams.delete("page");
      url.searchParams.delete("category");
      url.searchParams.delete("q");
      url.searchParams.delete("sort");
      if (state.selectedQuestionId) url.searchParams.set("question", state.selectedQuestionId);
      if (state.view === "ask") url.searchParams.set("ask", "1");
      if (state.view === "mine") url.searchParams.set("view", "mine");
      if (state.pagination.page > 1 && state.view !== "ask") url.searchParams.set("page", String(state.pagination.page));
      if (state.selectedCategory && state.view !== "ask") url.searchParams.set("category", state.selectedCategory);
      if (state.searchQuery && state.view !== "ask") url.searchParams.set("q", state.searchQuery);
      if (state.sort !== "recent" && state.view !== "ask") url.searchParams.set("sort", state.sort);
      return `${url.pathname}${url.search}${url.hash}`;
    }

    function questionUrl(questionId) {
      const url = new URL(window.location.href);
      url.searchParams.set("question", questionId);
      return `${url.pathname}${url.search}${url.hash}`;
    }
  }

  function emptyState(title, body) {
    return `<div class="forum-empty"><strong>${escapeHtml(title)}</strong><p>${escapeHtml(body)}</p></div>`;
  }

  function loginState() {
    return `<div class="forum-login"><p>Accedi al tuo account per vedere le domande inviate dal tuo profilo.</p><a href="/account/login">Accedi</a></div>`;
  }

  function paragraphs(value) {
    return String(value || "")
      .split(/\n{2,}/)
      .map((part) => `<p>${escapeHtml(part).replace(/\n/g, "<br>")}</p>`)
      .join("");
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalizeAppUrl(value) {
    const cleanValue = String(value || "").trim().replace(/\/$/, "");
    if (!cleanValue) return "";
    return /^https?:\/\//i.test(cleanValue) ? cleanValue : `https://${cleanValue}`;
  }

  function mergeForumCategories(apiCategories) {
    const bySlug = new Map((apiCategories || []).map((category) => [category.slug, category]));
    return FORUM_TAXONOMY.map((item) => ({
      ...item,
      ...(bySlug.get(item.slug) || {}),
      name: item.name,
      comingSoon: false,
    }));
  }

  function readSelectedProductGroups(root) {
    const script = root.querySelector("[data-forum-products-json]");
    if (!script) return {};
    try {
      const groups = JSON.parse(script.textContent || "{}");
      return Object.fromEntries(
        Object.entries(groups).map(([slug, products]) => [
          slug,
          normalizeSelectedProducts(products),
        ])
      );
    } catch (err) {
      return {};
    }
  }

  function normalizeSelectedProducts(products) {
    return (Array.isArray(products) ? products : [])
      .filter((product) => product && product.title)
      .map((product) => ({
        title: product.title,
        url: product.url || `/search?q=${encodeURIComponent(product.title)}`,
        image: product.image || "",
        vendor: product.vendor || "HeBio",
      }));
  }

  function excerpt(value, maxLength) {
    const text = String(value || "").trim();
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength).trim()}...`;
  }

  function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "short", year: "numeric" }).format(date);
  }

  function questionDate(question) {
    return question.originalQuestionDate || question.publishedAt || question.createdAt;
  }

  function questionAuthor(question) {
    return firstNameOnly(question?.authorName || question?.customerName) || "Anonimo";
  }

  function questionMeta(question) {
    const author = firstNameOnly(question.authorName || question.customerName);
    const date = formatDate(questionDate(question));
    if (author && date) return `${escapeHtml(author)} - ${date}`;
    return escapeHtml(author || date);
  }

  function viewsLabel(question) {
    const count = Number((question && question.viewCount) || 0);
    return `${count} visit${count === 1 ? "a" : "e"}`;
  }

  function firstNameOnly(value) {
    return String(value || "").trim().split(/\s+/)[0] || "";
  }

  function isInternalCategory(item) {
    const slug = String(item.categorySlug || item.slug || item.categoryName || item.name || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");
    return item.isInternalCategory || slug === "forum-importato";
  }

  function categoryPill(question) {
    if (isInternalCategory(question)) return "";
    return `<span class="forum-pill">${escapeHtml(question.categoryName || "Senza categoria")}</span>`;
  }

  function statusLabel(status) {
    const labels = {
      published: "Risposta ricevuta",
      resolved: "Risposta ricevuta",
      pending: "In attesa",
      closed: "Chiusa",
      hidden: "Nascosta",
    };
    return labels[String(status || "").toLowerCase()] || "In attesa";
  }
})();
